export default {
    root: function (_a) {
        var context = _a.context;
        return ({
            class: ['tw-relative tw-inline-block tw-shrink-0'],
        });
    },
    input: {
        class: 'tw-absolute tw-inset-0 tw-w-full tw-h-full tw-opacity-0 tw-cursor-pointer tw-z-10 tw-m-0 tw-p-0 tw-border-0',
    },
    slider: function (_a) {
        var context = _a.context;
        return ({
            class: [
                'tw-relative tw-inline-flex tw-h-5 tw-w-9 tw-rounded-full tw-border tw-transition-colors tw-duration-200 tw-ease-in-out',
                'tw-border-gray-300 dark:tw-border-gray-600',
                context.checked
                    ? 'tw-bg-primary-600 tw-border-primary-600'
                    : 'tw-bg-gray-200 dark:tw-bg-gray-600',
                context.disabled && 'tw-opacity-60 tw-cursor-not-allowed',
            ],
        });
    },
    handle: function (_a) {
        var context = _a.context;
        return ({
            class: [
                'tw-absolute tw-left-0.5 tw-top-1/2 tw--mt-2 tw-h-4 tw-w-4 tw-rounded-full tw-border tw-border-gray-300 tw-bg-white tw-shadow',
                'dark:tw-border-gray-600 dark:tw-bg-gray-800',
            ],
            style: {
                transition: 'transform 200ms ease-in-out',
                transform: context.checked ? 'translateX(0.875rem)' : 'translateX(0)',
            },
        });
    },
};
